import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "wrapper" }
const _hoisted_2 = { class: "font-weight-bold mb-4" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col-12" }
const _hoisted_5 = { class: "card" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "card-header bg-white" }, [
  /*#__PURE__*/_createElementVNode("h6", { class: "card-title" }, " Einstellungen ")
], -1)
const _hoisted_7 = { class: "card-body" }
const _hoisted_8 = { class: "table-responsive" }
const _hoisted_9 = { class: "table" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { class: "w-100 font-weight-bold" }, "Typ"),
    /*#__PURE__*/_createElementVNode("th", { class: "font-weight-bold" }, "Push"),
    /*#__PURE__*/_createElementVNode("th", { class: "font-weight-bold" }, "Email")
  ])
], -1)
const _hoisted_11 = { class: "custom-control custom-switch custom-control-dark" }
const _hoisted_12 = ["checked"]
const _hoisted_13 = /*#__PURE__*/_createElementVNode("label", {
  class: "custom-control-label",
  for: "slc_arming"
}, null, -1)
const _hoisted_14 = { class: "custom-control custom-switch custom-control-dark" }
const _hoisted_15 = ["checked"]
const _hoisted_16 = /*#__PURE__*/_createElementVNode("label", {
  class: "custom-control-label",
  for: "slc_arming2"
}, null, -1)
const _hoisted_17 = /*#__PURE__*/_createElementVNode("td", null, null, -1)
const _hoisted_18 = { class: "custom-control custom-switch custom-control-dark" }
const _hoisted_19 = ["checked"]
const _hoisted_20 = /*#__PURE__*/_createElementVNode("label", {
  class: "custom-control-label",
  for: "slc_alertPlan2"
}, null, -1)
const _hoisted_21 = { class: "card-footer text-right" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h1", _hoisted_2, _toDisplayString(_ctx.headline), 1),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _hoisted_6,
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("table", _hoisted_9, [
                _hoisted_10,
                _createElementVNode("tbody", null, [
                  _createElementVNode("tr", null, [
                    _createElementVNode("td", null, _toDisplayString(_ctx.notifications.arming.name), 1),
                    _createElementVNode("td", null, [
                      _createElementVNode("div", _hoisted_11, [
                        _createElementVNode("input", {
                          type: "checkbox",
                          class: "custom-control-input",
                          id: "slc_arming",
                          checked: _ctx.notifications.arming.checked.app,
                          onChange: _cache[0] || (_cache[0] = ($event: any) => (_ctx.notifications.arming.checked.app = !_ctx.notifications.arming.checked.app))
                        }, null, 40, _hoisted_12),
                        _hoisted_13
                      ])
                    ]),
                    _createElementVNode("td", null, [
                      _createElementVNode("div", _hoisted_14, [
                        _createElementVNode("input", {
                          type: "checkbox",
                          class: "custom-control-input",
                          id: "slc_arming2",
                          checked: _ctx.notifications.arming.checked.email,
                          onChange: _cache[1] || (_cache[1] = ($event: any) => (_ctx.notifications.arming.checked.email = !_ctx.notifications.arming.checked.email))
                        }, null, 40, _hoisted_15),
                        _hoisted_16
                      ])
                    ])
                  ]),
                  _createElementVNode("tr", null, [
                    _createElementVNode("td", null, _toDisplayString(_ctx.notifications.alertPlan.name), 1),
                    _hoisted_17,
                    _createElementVNode("td", null, [
                      _createElementVNode("div", _hoisted_18, [
                        _createElementVNode("input", {
                          type: "checkbox",
                          class: "custom-control-input",
                          id: "slc_alertPlan2",
                          checked: _ctx.notifications.alertPlan.checked.email,
                          onChange: _cache[2] || (_cache[2] = ($event: any) => (_ctx.notifications.alertPlan.checked.email = !_ctx.notifications.alertPlan.checked.email))
                        }, null, 40, _hoisted_19),
                        _hoisted_20
                      ])
                    ])
                  ])
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_21, [
            _createElementVNode("button", {
              class: "btn btn-primary",
              onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.saveNotificationConfig && _ctx.saveNotificationConfig(...args)))
            }, "Speichern")
          ])
        ])
      ])
    ])
  ]))
}